import { operators as o, common as c, BlacklistTypes } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'GuideElementsActivity',
    productArea: PRODUCT_AREAS.GUIDES,
    subProductArea: SUB_PRODUCT_AREAS.GUIDE_METRICS,
    responseFormat: 'rows',
    build: ({
        blacklist,
        guideId,
        currentIds,
        includeAnonymous,
        languageCode,
        segmentId,
        timeSeries,
    }: {
        blacklist?: BlacklistTypes;
        guideId: string;
        currentIds: Array<string>;
        includeAnonymous?: string | boolean;
        languageCode?: string;
        segmentId?: string;
        timeSeries: c.TimeSeries;
    }) => {
        return o.pipeline(
            o.sources.guideEvents({ guideId, timeSeries, blacklist }),
            o.filter('eventSubType(type) == "guideActivity"'),
            o.filter('uiElementType != ""'),
            o.evaluate({
                elementType: 'eventSubType(type)',
                isButton: 'if(uiElementType == "BUTTON", true, false)',
                isDismiss: 'if(contains(uiElementId, "pendo-close-guide-"), true, false)',
                isLink: 'if(uiElementType == "A", true, false)',
                isDeleted: `!contains(${JSON.stringify(currentIds)}, uiElementId)`,
                isSwipeLeft: 'if(uiElementType == "LEFT-SWIPER", true, false)',
                isSwipeRight: 'if(uiElementType == "RIGHT-SWIPER", true, false)',
            }),
            o.evaluate({
                elementType: 'if(isButton, "Button", elementType)',
            }),
            o.evaluate({
                elementType: 'if(isDismiss, "Close Button", elementType)',
            }),
            o.evaluate({
                elementType: 'if(isLink, "Link", elementType)',
            }),
            o.evaluate({
                elementType: 'if(isSwipeLeft, "Swiped Left", elementType)',
            }),
            o.evaluate({
                elementType: 'if(isSwipeRight, "Swiped Right", elementType)',
            }),
            o.languageFilter(languageCode),
            o.identified(includeAnonymous),
            o.segment(segmentId),
            o.fork(
                o.pipeline(
                    o.group(['uiElementId', 'elementType', 'isDeleted'], o.groupField('numClicks', o.count(null))),
                ),
                o.pipeline(
                    o.group(['uiElementId', 'uiElementText'], o.groupField('mostRecent', { max: 'browserTime' })),
                    o.sort(['-mostRecent']),
                    o.group(['uiElementId'], o.groupField('uiElementText', o.first('uiElementText'))),
                ),
                o.pipeline(
                    o.group(['uiElementId', 'uiElementActions'], o.groupField('mostRecent', { max: 'browserTime' })),
                    o.sort(['-mostRecent']),
                    o.group(['uiElementId'], o.groupField('uiElementActions', o.first('uiElementActions'))),
                ),
            ),
            o.join('uiElementId'),
            o.select({
                guideId: 'guideId',
                uiElementId: 'uiElementId',
                uiElementType: 'elementType',
                uiElementActions: 'uiElementActions',
                uiElementText: 'uiElementText',
                numClicks: 'numClicks',
                isDeleted: 'isDeleted',
            }),
        );
    },
};
